"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var Mailto = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Mailto, _React$Component);

  function Mailto() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Mailto);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Mailto)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.generateHref = function (_ref) {
      var email = _ref.email,
          subject = _ref.subject;
      return "mailto:".concat(email).concat(subject ? '?subject=' + subject : '');
    };

    return _this;
  }

  (0, _createClass2.default)(Mailto, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style;
      var _this$props2 = this.props,
          email = _this$props2.email,
          subject = _this$props2.subject;

      if (!email) {
        return null;
      }

      return _react.default.createElement("a", {
        href: "".concat(this.generateHref({
          email: email,
          subject: subject
        }))
      }, children);
    }
  }]);
  return Mailto;
}(_react.default.Component);

Mailto.defaultProps = {
  email: null,
  subject: null
};
var _default = Mailto;
exports.default = _default;